const isEmptyObject = (value) =>
  value instanceof Object &&
  !Array.isArray(value) &&
  !Object.keys(value).length;

const isEmptyArray = (value) => Array.isArray(value) && !value.length;

export const isEmpty = (value) => {
  switch (value) {
    case '':
    case 0:
    case false:
    case null:
    case undefined:
      return true;

    default:
      if (isEmptyArray(value)) return true;
      if (isEmptyObject(value)) return true;

      return false;
  }
};
